export enum ProfileVehicleType {
  Truck = 3, //"Heavy Duty
  MidsizeTruck = 12, // Medium Duty
  LightDuty = 11, // Light Duty
  Auto = 0, // Auto
  Bus = 4, // Bus
}

export enum RoutingType {
  Practical = 0,
  Shortest = 1,
  Fastest = 2,
}

export enum TollRoadsType {
  AlwaysAvoid = 1, // Always Avoid
  AvoidIfPossible = 2, // Avoid If Possible
  Use = 3, // Use
}

export enum TruckDimensions {
  NoRestriction = 0, // No Restriction
  SemiTrailer48 = 1, // Heavy Duty Semitrailer (48' x 96\")
  TrailerOrTwins53 = 2, // 53' Trailer or Twins
  DoubleTrailers28 = 3, // Heavy Duty Doubles
  StraightTruck40 = 4, // Heavy Duty Straight
  EU16Meter = 5, // 16.5 Meter EU Truck
  EU18Meter = 6, // 18.75 Meter EU Truck
  EU12Meter = 7, // 12 Meter EU Truck
  EU54Foot = 8, // 54 Foot EU Truck
  EU61Foot = 9, // 61 Foot EU Truck
  EU40Foot = 10, // 40 Foot EU Truck
  Custom = 16, // Use Custom Size Restrictions
  ConventionalSchoolBus = 17,
  SmallSchoolBus = 18,
}

export enum HazmatType {
  None = 0, // None
  General = 1, // General
  Explosives = 2, // Explosives
  Flammable = 6, // Flammable
  Inhalants = 3, // Inhalants
  Caustic = 5, // Caustic
  Radioactive = 4, // Radioactive
  HarmfulToWater = 7, // Harmful To Water
  Tunnel = 8, // Tunnel
}

export enum TunnelRestrictions {
  None = 0, // None
  EUTunnelBCDE = 8, // B, C, D, E Prohibited
  EUTunnelCDE = 9, // C, D, E Prohibited
  EUTunnelDE = 10, // D, E Prohibited
  EUTunnelE = 11, // E Prohibited
}

export enum DisplayRestrictionsType {
  BasedOnTruckRestrictions = 2, // Based on Truck Restrictions
  AlwaysOn = 1, // Always On
  AlwaysOff = 0, // Always Off
}

export interface VehicleGroups {
  Id: number;
  Name: string;
  ConfigurationSettingsId?: number;
  SpeedCoachingProfileId?: number;
}
export enum VehicleDimUnits {
  English = 0,
  Metric = 1,
}
export enum DistanceUnits {
  Miles = 0,
  Kilometers = 1,
}
export enum ClassOverrideType {
  None = 0x0,
  FiftyThreeFoot = 0x1,
  NationalNetwork = 0x2,
  ALL = 0x3,
}
export enum VolumeUnits {
  Gallons = 0,
  Liters = 1,
}
export enum AvoidFavorType {
  StronglyFavor = 50, // Strongly Favor
  Favor = 75,
  Neutral = 100,
  Avoid = 150,
  StronglyAvoid = 200, // Strongly Avoid
}
export enum ProfileSideOfStreetAdherenceLevel {
  Off = 0,
  Minimal = 1,
  Moderate = 2,
  Average = 3,
  Strict = 4,
  Adhere = 5,
  StronglyAdhere = 6,
}
export enum EUTrailerType {
  None = 1,
  Caravan = 2,
  Trailer = 3,
}
export enum EUEmissionType {
  EuroI = 3, // Euro I
  EuroII = 4, // Euro II
  EuroIII = 5, // Euro III
  EuroIV = 6, // Euro IV
  EuroV = 7, // Euro V
  EuroVI = 8, // Euro VI
}
export enum FuelType {
  Petrol = 0,
  Petrol_E5 = 1,
  Petrol_E10 = 2,
  Ethanol = 3,
  Diesel = 4,
  Biodiesel = 5,
  Diesel_D5 = 6,
  Diesel_D7 = 7,
  Count = 8,
}

export interface EUProfile {
  hasTrailer?: boolean;
  isHybrid: boolean;
  minPoll: boolean;
  refrigerated: boolean;
  trailerType?: EUTrailerType;
  emiType?: EUEmissionType;
  fuelType?: FuelType;
  trailerCount?: number;
  trailerMaxAxles?: number;
  trailerMaxHt?: number; // inches vs meters
  trailerMaxWt?: number; // pounds vs kilograms;
  fuelConsumption?: number;
}

export interface RoutingProfile {
  routingProfileId?: number; // Id
  OwnerId?: number;
  AccountId?: number;
  name: string;
  vehicleType: ProfileVehicleType;
  routingType: RoutingType;
  tollRoadType: TollRoadsType;
  truckDimensions: TruckDimensions;
  maxHeight?: number; // 0 to max inches or meters
  maxWidth?: number; // 0 to max inches or meters
  totalLength?: number; // 0 to max inches or meters
  totalWeight?: number; // 0 to max pounds or kilograms
  MaxWeightPerAxleGroup?: number; // 0 to max
  totalWeightPerAxle?: number; // 0 to max pounds or kilograms
  congestionZone: number;
  environmentalZone: number;
  ultraLowEmissionZone?: number;
  hazmatType: HazmatType;
  tunnelRestriction?: TunnelRestrictions;
  displayRestrictions: DisplayRestrictionsType;
  nationalNetwork: boolean;
  fiftyThreeFootTrailer: boolean;
  overrideRestrictions: boolean;
  bordersOpen: boolean;
  propane?: boolean;
  ferryClosed?: boolean;
  VehicleGroups: Array<VehicleGroups>;
  revision?: string;
  statusDeleted?: boolean;
  unitsOfMeasure?: VehicleDimUnits;
  numAxles?: number;
  LCV?: boolean;
  distanceUnits?: DistanceUnits;
  tollDiscouraged?: boolean;
  classOverrides?: ClassOverrideType;
  highwayOnly?: boolean;
  includeFerryDistance?: boolean;
  tollCurrency?: number;
  exchangeRate?: string;
  fuelUnits?: VolumeUnits;
  costGHG?: string;
  costPerFuelUnit?: string;
  fuelEconomyLoad?: string;
  fuelEconomyEmpty?: string;
  costMaintLoad?: string;
  costMaintEmpty?: string;
  costTimeLoad?: string;
  costTimeEmpty?: string;
  dataVersion?: string;
  hubRouting?: boolean;
  tollDiscountPlans?: string;
  includeTollData?: boolean;
  default?: boolean;
  roadPreferencesFreewaysAFType?: AvoidFavorType;
  roadPreferencesFreewaysSpeed?: number; // the total number of miles per hour, is total number of kilometers per hour
  roadPreferencesDividedHighwaysAFType?: AvoidFavorType;
  roadPreferencesDividedHighwaysSpeed?: number; // the total number of miles per hour, is total number of kilometers per hour
  roadPreferencesPrimaryRoadsAFType?: AvoidFavorType;
  roadPreferencesPrimaryRoadsSpeed?: number; // total number of miles per hour, total number of kilometers per hour
  roadPreferencesSecondaryRoadsAFType?: AvoidFavorType;
  roadPreferencesSecondaryRoadsSpeed?: number; // total number of miles per hour, total number of kilometers per hour
  roadPreferencesLocalStreetsAFType?: AvoidFavorType;
  roadPreferencesLocalStreetsSpeed?: number; // total number of miles per hour, total number of kilometers per hour
  modifiedOn?: number;
  isFerryDiscouraged?: boolean;
  elevationLimit?: number; // If this is null, no limit is set.
  governorSpeedLimit?: number; // If this is null, no limit is set.
  sideOfStreetAdherence?: ProfileSideOfStreetAdherenceLevel;
  useAvoidFavors?: boolean;
  useTraffic?: boolean;
  useSites?: boolean;
  euProfile: EUProfile;
}
export enum PostCodeType {
  US = 0,
  Mexico = 1,
  Both = 2,
}
export enum CountryAbbreviationType {
  FIPS = 0,
  ISO2 = 1,
  ISO3 = 2,
  GENC2 = 3,
  GENC3 = 4,
}
export interface Address {
  StreetAddress?: string;
  City?: string;
  State?: string;
  Zip?: string;
  County?: string;
  Country?: string;
  SPLC?: string;
  CountryPostalFilter?: PostCodeType;
  AbbreviationFormat?: CountryAbbreviationType;
  StateName?: string;
  StateAbbreviation?: string;
  CountryAbbreviation?: string;
}

export interface Coordinates {
  Lat: string;
  Lon: string;
}
export enum DataRegion {
  Unknown = 0,
  AF = 1,
  AS = 2,
  EU = 3,
  NA = 4,
  OC = 5,
  SA = 6,
  ME = 7,
  MX = 8,
}
export enum FPCGeocodes {
  NTBasic = 0x1,
  NTPremium = 0x2,
  OSNI = 0x4,
}
export interface Location {
  Address: Address;
  Coords?: Coordinates;
  Region?: DataRegion;
  Label?: string;
  PlaceName?: string;
  PlaceId?: string;
  SpeedLimitHeading?: number;
  SplitHouseNumber?: boolean;
  IncludeTrimblePlaceIDs?: boolean;
  FPCCode?: FPCGeocodes;
}

export enum StopType {
  Origin = 1,
  Work = 2,
  Waypoint = 3,
  FuelStop = 4,
  RestStopShort = 5,
  RestStopLong = 6,
  RestStopCycleReset = 7,
  Destination = 9,
  Delivery = 10,
  Pickup = 11,
  RendezVous = 12,
  RestStopFullDay = 13,
  RestStopDriverSwitch = 14,
  BorderCrossing = 15,
  Break = 16,
  RestStopShortSplittable = 17,
  RestStopBiWeekly = 18,
  Unplanned = 19,
  DailyShiftGapStop = 20,
  BreakTimeInDay = 21,
  BreakTimeInWeek = 22,
}

export interface StopInfo {
  Location?: Location;
  Waypoint?: boolean;
  stopType?: StopType;
}

export interface Trip {
  Id: number;
  Name: string;
  Profile: RoutingProfile;
  ModifiedOn: number;
  Stops: Array<StopInfo>;
}

export interface DataCreated {
  Id: number;
  ModifiedOn: number;
  Guid?: any; // todo
}

export interface DataUpdated {
  ItemsModified: number;
  ModifiedOn: number;
}
